<template>
  <div class="d-flex flex-column gap-3">
    <div class="d-flex justify-content-between align-items-center p-2 bg-light rounded border">
      <div>
        <h5 class="mb-0">Uprawnienia</h5>
        <small class="text-muted">Katalog uprawnień systemowych</small>
      </div>
    </div>

    <div v-if="!canViewPrivilegesAccess" class="alert alert-warning mb-0">
      Brak uprawnień do przeglądania uprawnień.
    </div>

    <CommonTable2
      v-else
      :key="tableConfig.data"
      :table="tableConfig"
      rowIdentifier="id"
      :currentPage="currentPage"
      :totalRows="totalRows"
      :totalPages="totalPages"
      :showPaginationBottom="true"
      :showPaginationTop="false"
      :showMassActions="false"
      :multiselect="false"
      :showRowActions="true"
      @onPageChange="handlePageChange"
      @onSort="handleSort"
      @onItemAction="handleItemAction"
      :per-page="pageSize"
    />

    <PrivilegeDetailsModal
      v-if="selectedPrivilege"
      v-model:showModal="showDetailsModal"
      :privilege="selectedPrivilege"
    />
  </div>
</template>

<script>
import CommonTable2 from "@/components/widgets/CommonTable2.vue";
import PrivilegeDetailsModal from "@/views/UserCommonManager/components/PrivilegeDetailsModal.vue";
import { useUserRbacManagerModule } from "@/state/pinia/userRbacManagerModule";
import { canViewPrivileges } from "@/helpers/rbacAccess";

export default {
  name: "PrivilegesCatalogView",
  components: { CommonTable2, PrivilegeDetailsModal },
  data() {
    return {
      currentPage: 1,
      totalRows: 0,
      totalPages: 1,
      pageSize:20,
      sortColumn: "id",
      sortingDirection: "ASC",
      privileges: [],
      selectedPrivilege: null,
      showDetailsModal: false,
      tableConfig: {
        headers: [
          { key: "name", text: "Klucz", type: "text", sortable: true, width: "220px" },
          { key: "displayName", text: "Nazwa", type: "text", sortable: true, width: "220px" },
          { key: "description", text: "Opis", type: "text", sortable: false, width: "280px" },
          { key: "actions", text: "Akcje", type: "actions", sortable: false, width: "100px" },
        ],
        data: [],
      },
    };
  },
  computed: {
    rbacModule() {
      return useUserRbacManagerModule();
    },
    canViewPrivilegesAccess() {
      return canViewPrivileges();
    },
  },
  methods: {
    handlePageChange(page) {
      this.currentPage = page;
      this.refreshPrivilegesList();
    },
    handleSort(sortingKeyValue) {
      this.sortColumn = sortingKeyValue;
      this.currentPage = 1;
      this.refreshPrivilegesList();
    },
    handleItemAction(event) {
      if (event.action.action === "view-details") {
        this.selectedPrivilege = event.itemData;
        this.showDetailsModal = true;
      }
    },
    refreshPrivilegesList() {
      if (!this.canViewPrivilegesAccess) return;
      this.rbacModule
        .httpGetPrivilegesPaging({
          currentPage: this.currentPage,
          sortingKey: this.sortColumn,
          sortingDirection: this.sortingDirection,
          pageSize:this.pageSize
        })
        .then(() => {
          this.privileges = [...this.rbacModule.getPrivileges];
          this.totalPages = this.rbacModule.getPrivilegesPagesCount || 1;
          this.totalRows = this.rbacModule.getPrivilegesDataTotal || 0;
          this.tableConfig.data = this.privileges.map((privilege) => ({
            ...privilege,
            id: privilege.id || privilege.privilegeId || privilege.key,
            key: privilege.key || privilege.privilegeKey || "-",
            name: privilege.name || privilege.key || "-",
            description: privilege.description || privilege.details || "-",
            actions: [
              {
                icon: "fas fa-info-circle",
                action: "view-details",
                tooltip: "Szczegóły",
                enabled: true,
                class: "btn btn-sm btn-outline-primary",
              },
            ],
          }));
        });
    },
  },
  mounted() {
    this.refreshPrivilegesList();
  },
};
</script>
